module.exports = __webpack_public_path__ + "img/calendar-plus-icon-orange.b0e6e7b3.svg";